export const OFFLINE_DB_NAME = "BUSKA_PORTAL";

export const offline_tables = {
    all_invoices: "all_invoices",
};